const aboutUsResources = {
    title: 'About Us',
};
export default aboutUsResources;